module.exports = __webpack_public_path__ + "bb792117.png";